import {
	actionsPath,
	applicationListPath,
	appPath,
	customCaptionsPath,
	defectRiskRatingsPath,
	defectStatusesPath,
	defectTypesPath,
	feedbackClassificationsPath,
	feedbackPrioritiesPath,
	feedbackStatusesPath,
	missingItemsPath,
	modelStatusesPath,
	modelTypesPath,
	operatingModesPath,
	pausesPath,
	positionsPath,
	rolesPath,
	skippedTasksPath,
	StatusChangesPath,
	stopsPath,
	systemsPath,
} from "helpers/routePaths";

import i18n from "i18n";

/**
 * NOTE: This is currently a helper. In production, this data may come from either the API
 * or can be hard coded. Probably not approproate as a helper function
 */
const ApplicationNavigation = (id) => {
	// Setting navigation links with correct application ID
	const navigation = [
		{
			name: i18n.t("title.details"),
			dropdown: [
				{
					title: i18n.t("label.application"),
					link: `${appPath}${applicationListPath}/${id}`,
				},
				{
					title: i18n.t("label.customCaptions"),
					link: `${appPath}${applicationListPath}/${id}${customCaptionsPath}`,
				},
			],
		},
		{
			name: i18n.t("label.reasonDefinitions"),
			dropdown: [
				{
					title: i18n.t("label.pauses"),
					link: `${appPath}${applicationListPath}/${id}${pausesPath}`,
				},
				{
					title: i18n.t("label.stops"),
					link: `${appPath}${applicationListPath}/${id}${stopsPath}`,
				},
				{
					title: i18n.t("label.skippedTasks"),
					link: `${appPath}${applicationListPath}/${id}${skippedTasksPath}`,
				},
				{
					title: i18n.t("label.missingPartOrTools"),
					link: `${appPath}${applicationListPath}/${id}${missingItemsPath}`,
				},
				{
					title: i18n.t("label.statusChanges"),
					link: `${appPath}${applicationListPath}/${id}${StatusChangesPath}`,
				},
			],
		},
		{
			name: i18n.t("title.modelDefinitions"),
			dropdown: [
				{
					title: i18n.t("label.statuses"),
					link: `${appPath}${applicationListPath}/${id}${modelStatusesPath}`,
				},
				{
					title: i18n.t("entity.type", { count: 2 }),
					link: `${appPath}${applicationListPath}/${id}${modelTypesPath}`,
				},
			],
		},
		{
			name: i18n.t("title.taskDefinitions"),
			dropdown: [
				{
					title: i18n.t("entity.actionRequired", { count: 2 }),
					link: `${appPath}${applicationListPath}/${id}${actionsPath}`,
				},
				{
					title: i18n.t("entity.system", { count: 2 }),
					link: `${appPath}${applicationListPath}/${id}${systemsPath}`,
				},
				{
					title: i18n.t("entity.operatingMode", { count: 2 }),
					link: `${appPath}${applicationListPath}/${id}${operatingModesPath}`,
				},
			],
		},
		{
			name: i18n.t("title.userDefinitions"),
			dropdown: [
				{
					title: i18n.t("entity.position", { count: 2 }),
					link: `${appPath}${applicationListPath}/${id}${positionsPath}`,
				},
				{
					title: i18n.t("entity.role", { count: 2 }),
					link: `${appPath}${applicationListPath}/${id}${rolesPath}`,
				},
			],
		},
		{
			name: i18n.t("title.defectDefinitions"),
			dropdown: [
				{
					title: i18n.t("entity.riskRating", { count: 2 }),
					link: `${appPath}${applicationListPath}/${id}${defectRiskRatingsPath}`,
				},
				{
					title: i18n.t("label.statuses"),
					link: `${appPath}${applicationListPath}/${id}${defectStatusesPath}`,
				},
				{
					title: i18n.t("entity.type", { count: 2 }),
					link: `${appPath}${applicationListPath}/${id}${defectTypesPath}`,
				},
			],
		},
		{
			name: i18n.t("title.feedbackDefinitions"),
			dropdown: [
				{
					title: i18n.t("entity.classification", { count: 2 }),
					link: `${appPath}${applicationListPath}/${id}${feedbackClassificationsPath}`,
				},
				{
					title: i18n.t("entity.priority", { count: 2 }),
					link: `${appPath}${applicationListPath}/${id}${feedbackPrioritiesPath}`,
				},
				{
					title: i18n.t("label.statuses"),
					link: `${appPath}${applicationListPath}/${id}${feedbackStatusesPath}`,
				},
			],
		},
	];

	return navigation;
};

export default ApplicationNavigation;
